import {toast} from "react-toastify";
import XLSX from "xlsx/dist/xlsx.full.min";

const toPrint = (tableRef) => {
  if (tableRef !== null && tableRef !== undefined) {
    tableRef.table.print(true, false);
  } else {
    toast("اطلاعاتی جهت پی دی اف وجود ندارد");
  }
};

const toExcel = (tableRef, prices) => {
  console.log(tableRef);
  const tableData = tableRef.table.getData("active"); // Get the table data
  const columns = tableRef.table.getColumns(); // Get the column definitions

  // Convert the Tabulator data to an array of objects with column titles instead of field names
  const jsonData = tableData.map((row) => {
    const rowData = {};
    columns.forEach((column) => {
      const field = column.getField();
      const value = row[field];
      /*
      field !== undefined &&
      (prices.includes(field)
        ? (rowData[column.getDefinition().title] = parseInt(value, 10))
        : (rowData[column.getDefinition().title] = value));
        */
      // Convert string value to integer

      // force Convert All Data To int
      rowData[column.getDefinition().title] = parseFloat(value, 10) ? parseFloat(value, 10) : value

    });

    return rowData;
  });
  // Create a worksheet from the JSON data
  const worksheet = XLSX.utils.sheet_add_json({}, jsonData);
  // Create a workbook and add the worksheet to it
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  // Export the workbook to an XLSX file
  XLSX.writeFile(workbook, "data.xlsx");
};

const exportTabulatorData = {
  toPrint,
  toExcel,
};

export default exportTabulatorData;
